import * as Yup from 'yup'
import {ExtraLongHTML} from 'Validations'
export const Validation = Yup.object().shape({
  portfolio: ExtraLongHTML.required('Portfolio is required.'),
})
